import { render, staticRenderFns } from "./AgendamentoEntregaAdm.vue?vue&type=template&id=356c1e2a&"
import script from "./AgendamentoEntregaAdm.vue?vue&type=script&lang=js&"
export * from "./AgendamentoEntregaAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports